"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _List = _interopRequireDefault(require("@material-ui/core/List"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _ListItem = _interopRequireDefault(require("../ListItem"));

var _ListSubheader = _interopRequireDefault(require("../ListSubheader"));

var _styles2 = require("./styles");

var _reactSortablejs = _interopRequireDefault(require("react-sortablejs"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var List = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(List, _Component);

  var _super = _createSuper(List);

  function List() {
    var _this;

    (0, _classCallCheck2.default)(this, List);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          listItems = _this$props.listItems,
          listSubheader = _this$props.listSubheader,
          subheaders = _this$props.subheaders,
          className = _this$props.className,
          draggable = _this$props.draggable,
          onChange = _this$props.onChange,
          classes = _this$props.classes,
          sideNav = _this$props.sideNav,
          wrapperStyles = _this$props.wrapperStyles,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["id", "listItems", "listSubheader", "subheaders", "className", "draggable", "onChange", "classes", "sideNav", "wrapperStyles"]);

      if (listItems || subheaders) {
        return /*#__PURE__*/_react.default.createElement(_List.default, (0, _extends2.default)({
          id: id,
          className: (0, _classnames.default)("prmbl-list", className, wrapperStyles ? classes.hasPaper : classes.noPaper, (0, _defineProperty2.default)({}, classes.sideNav, sideNav))
        }, rest, {
          subheader: listSubheader
        }), listItems && buildContents({
          draggable: draggable,
          listItems: listItems,
          id: id,
          onChange: onChange,
          classes: classes
        }), subheaders && subheaders.map(function (sh, i) {
          var disableSticky = sh.disableSticky,
              inset = sh.inset;
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
            key: "".concat(id, "-subheader-wrapper-").concat(i)
          }, /*#__PURE__*/_react.default.createElement(_ListSubheader.default, {
            id: "".concat(id, "-listSubheader-").concat(i),
            disableSticky: disableSticky,
            inset: inset
          }, sh.children), sh.listItems && sh.listItems.map(function (item, index) {
            return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
              classes: {
                secondaryAction: classes.secondaryAction
              },
              key: index,
              id: "".concat(id, "-listSubheader-").concat(i, "-listItem-").concat(index),
              iconLocation: item.iconLocation,
              isSideNav: item.itemSideNav,
              isProductDropdown: item.itemProductDropdown
            }, item));
          }));
        }, (0, _assertThisInitialized2.default)(_this)));
      }
    });
    return _this;
  }

  return List;
}(_react.Component);

exports.List = List;
(0, _defineProperty2.default)(List, "propTypes", {
  /**
   * The html id.
   */
  id: _propTypes.default.string.isRequired,

  /**
   * function to be called when a list item is dragged to another position in the list.
   *
   * (orderedList, sortable, event) => void
   * orderedList => the array of dataIds provided to the listItems
   * sortable => the sortable object provided by react-sortablejs library
   * event => the event source object
   */
  onChange: _propTypes.default.func,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   *
   * Sets whether there's a background and border around the list.
   */
  wrapperStyles: _propTypes.default.bool,

  /**
   * @ignore
   *
   * For sidenav styles
   */
  sideNav: _propTypes.default.bool,

  /**
   * The contents of ListItem.
   */
  listItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * the id attribute to be placed on the item for the draggable list.
     */
    dataId: _propTypes.default.string,

    /**
     * If true, the list item will be a button.
     */
    button: _propTypes.default.bool,

    /**
     * The content of the component.
     */
    children: _propTypes.default.node,

    /**
     * If true, a 1px light border is added to the bottom of the list item.
     */
    divider: _propTypes.default.bool,

    /**
     *  The [ListItemAvatar](#listitemavatar) for the list item.
     */
    itemAvatar: _propTypes.default.node,

    /**
     * The [ListItemIcon](#listitemicon) for the list item.
     */
    itemIcon: _propTypes.default.node,

    /**
     * Location of Icon or Avatar. If left, Icon or Avatar is located
     * left side of Text.
     */
    iconLocation: _propTypes.default.oneOf(["left", "right"]),

    /**
     * The [ListSecondaryAction](#listsecondaryaction) for the list item
     * (eg. [Checkbox](#checkbox), [Toggle](#toggle)).
     */
    itemSecondaryAction: _propTypes.default.node,

    /**
     * @ignore
     *
     * For sidenav styles
     */
    itemSideNav: _propTypes.default.bool,

    /**
     * The [ListItemText](#listitemtext) of the list item.
     */
    itemText: _propTypes.default.shape({
      /**
       * Alias for the primary property.
       */
      children: _propTypes.default.node,

      /**
       * If true, the children will be indented. This should be
       * used if there is no left avatar or left icon.
       */
      inset: _propTypes.default.bool,

      /**
       * The main content element.
       */
      primary: _propTypes.default.node,

      /**
       * The secondary content element.
       */
      secondary: _propTypes.default.node
    }),
    // Indicate whether to hide the item
    hide: false
  }).isRequired),

  /**
   * The content of the [ListSubheader](#listsubheader).
   */
  listSubheader: _propTypes.default.node,

  /**
   * Additional subheaders which separate the list into different sections.
   */
  subheaders: _propTypes.default.arrayOf(_propTypes.default.shape({
    /**
     * Content of the subheader.
     */
    children: _propTypes.default.node,

    /**
     * If true, the ListSubheader will not stick to the top during scroll.
     */
    disableSticky: _propTypes.default.bool,

    /**
     * If true, the ListSubheader will be indented.
     */
    inset: _propTypes.default.bool,

    /**
     * The items that go under the specific subheader. See listItems property above for the properties.
     */
    listItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      /**
       * If true, the list item will be a button.
       */
      button: _propTypes.default.bool,

      /**
       * The content of the component.
       */
      children: _propTypes.default.node,

      /**
       * If true, a 1px light border is added to the bottom of the list item.
       */
      divider: _propTypes.default.bool,

      /**
       *  The [ListItemAvatar](#listitemavatar) for the list item.
       */
      itemAvatar: _propTypes.default.node,

      /**
       * The [ListItemIcon](#listitemicon) for the list item.
       */
      itemIcon: _propTypes.default.node,

      /**
       * Location of ListIcon or ListAvatar. If left, ListIcon or ListAvatar is located
       * left side of ListText.
       */
      iconLocation: _propTypes.default.oneOf(["left", "right"]),

      /**
       * The [ListSecondaryAction](#listsecondaryaction) for the list item
       * (eg. [Checkbox](#checkbox), [Toggle](#toggle)).
       */
      itemSecondaryAction: _propTypes.default.node,

      /**
       * @ignore
       *
       * For sidenav styles
       */
      itemSideNav: _propTypes.default.bool,

      /**
       * @ignore
       *
       * For product dropdown styles
       */
      itemProductDropdown: _propTypes.default.bool,

      /**
       * The [ListItemText](#listitemtext) of the list item.
       */
      itemText: _propTypes.default.shape({
        /**
         * Alias for the primary property.
         */
        children: _propTypes.default.node,

        /**
         * If true, the children will be indented. This should be
         * used if there is no left avatar or left icon.
         */
        inset: _propTypes.default.bool,

        /**
         * The main content element.
         */
        primary: _propTypes.default.node,

        /**
         * The secondary content element.
         */
        secondary: _propTypes.default.node
      })
    }))
  })),

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,
  draggable: _propTypes.default.bool,

  /**
   * The label to render for this list for accessibility
   */
  "aria-label": _propTypes.default.string
});
(0, _defineProperty2.default)(List, "defaultProps", {
  className: ""
});

var buildContents = function buildContents(_ref) {
  var draggable = _ref.draggable,
      listItems = _ref.listItems,
      id = _ref.id,
      _onChange = _ref.onChange,
      classes = _ref.classes;

  if (draggable) {
    return /*#__PURE__*/_react.default.createElement(_reactSortablejs.default, {
      onChange: function onChange(order, sortable, evt) {
        _onChange && _onChange(order, sortable, evt);
      },
      options: {
        name: id,
        // If same name, columns can drag and drop between
        pull: false,
        // Allow items from this list to be pulled out
        put: false // Allows items from other lists to be put into this list

      }
    }, listItems.map(function (item, i) {
      if (item.hide) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
        classes: {
          secondaryAction: classes.secondaryAction
        },
        className: classes.isSortable,
        key: i,
        "data-id": item.dataId,
        id: "".concat(id, "-listItem-").concat(i),
        iconLocation: item.iconLocation,
        isSideNav: item.itemSideNav
      }, item));
    }));
  }

  return listItems.map(function (item, i) {
    return !item.hide ? /*#__PURE__*/_react.default.createElement(_ListItem.default, (0, _extends2.default)({
      classes: {
        secondaryAction: classes.secondaryAction
      },
      key: i,
      id: "".concat(id, "-listItem-").concat(i),
      iconLocation: item.iconLocation,
      isSideNav: item.itemSideNav
    }, item)) : null;
  });
};

buildContents.propTypes = {
  draggable: _propTypes.default.bool,
  listItems: _propTypes.default.array,
  id: _propTypes.default.string,
  onChange: _propTypes.default.func,
  classes: _propTypes.default.object
};

var _default = (0, _styles.withStyles)(_styles2.styles)(List);

exports.default = _default;